import React from "react";
import ModalValidarPago from './ModalValidarPago'; // Ajusta la ruta de importacion si es necesario
import AvisoSoloLectura from './AvisoSoloLectura';
import { rolDeSesion, esAdministrador, veCobroConPinpad, veValidarPago, MENSAJE_SOLO_LECTURA } from '../utilities/permisos';

const VistaCobroAspirantes = (props) => {
  const {
    folioBusqueda, setFolioBusqueda, aspiranteInfo, cargando, mostrarModalValidacion,
    folioBanco, setFolioBanco,
    bancoSeleccionado, setBancoSeleccionado, loadingValidacion,
    buscarAspirantePorFolio, abrirModalValidacion, confirmarValidacionPago, limpiarModulo,
    procesarCobroPinpad,
    modalExito, setModalExito, cerrarModal
  } = props;

  // Extraemos el rol del localStorage
  const rolCajero = rolDeSesion();
  const soloLectura = esAdministrador(rolCajero); // ve los botones de cobrar y validar, deshabilitados

  return (
    <div style={{ fontFamily: "sans-serif", marginTop: "10px" }}>
      {/* SECCIÓN 1: BUSCADOR DE FOLIO */}
      <div className="catalogo-section" style={{ marginBottom: "20px" }}>
        <div className="catalogo-header">
          <h3>📋 Módulo de Validación: Aspirantes / Preinscripciones</h3>
          <p>Ingresa el número de folio impreso en la ficha de preinscripción del aspirante.</p>
        </div>
        <form onSubmit={buscarAspirantePorFolio} style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
          <input
            type="text"
            className="search-input"
            placeholder="Ej. 2026A12345 (Folio de Aspirante)"
            value={folioBusqueda}
            onChange={(e) => setFolioBusqueda(e.target.value)}
            disabled={cargando}
            style={{ flex: 1 }}
          />
          <button type="submit" className="btn-search" disabled={cargando} style={{ backgroundColor: "#003366" }}>
            {cargando ? "Buscando..." : "🔍 Buscar Aspirante"}
          </button>
          {aspiranteInfo && (
            <button type="button" className="btn-logout" onClick={limpiarModulo} style={{ backgroundColor: "#6c757d", width: "auto" }}>
              Limpiar
            </button>
          )}
        </form>
      </div>

      {/* SECCIÓN 2: DATOS DEL ASPIRANTE ENCONTRADO */}
      {aspiranteInfo && (
        <div className="Dashboard-card" style={{ animation: "fadeIn 0.3s ease" }}>
          <div style={{ backgroundColor: "#f1f5f9", padding: "15px", borderRadius: "6px", marginBottom: "20px", borderLeft: "5px solid #003366" }}>
            <h4 style={{ margin: "0 0 8px 0", color: "#003366", fontSize: "1.2rem" }}>Datos de Confirmación del Aspirante</h4>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "10px", fontSize: "0.95rem" }}>
              <p className="sin-margen"><strong>Nombre Completo:</strong> {aspiranteInfo.nombre_completo}</p>
              <p className="sin-margen"><strong>Folio Sistema:</strong> {aspiranteInfo.pre_strfolio}</p>
              <p className="sin-margen"><strong>CURP:</strong> {aspiranteInfo.curp || "Sin registro"}</p>
              <p className="sin-margen"><strong>Plantel:</strong> {aspiranteInfo.plantel || "Cargando..."}</p>
              <p className="sin-margen"><strong>Aula Externa:</strong> {aspiranteInfo.aula_externa || "No aplica"}</p>
              <p className="sin-margen"><strong>Carrera:</strong> {aspiranteInfo.carrera || "Cargando..."}</p>
              <p className="sin-margen"><strong>Estatus Actual:</strong> 
                <span style={{ marginLeft: "5px", padding: "2px 8px", borderRadius: "10px", fontWeight: "bold", fontSize: "0.85rem",
                  backgroundColor: aspiranteInfo.pre_validapago === "1" ? "#e6f4ea" : "#fce8e6",
                  color: aspiranteInfo.pre_validapago === "1" ? "#137333" : "#c5221f"
                }}>
                  {aspiranteInfo.pre_validapago === "1" ? "PAGADO" : "PENDIENTE DE VALIDAR"}
                </span>
              </p>
            </div>
          </div>

          {/* === NUEVA SECCIÓN CONDICIONAL ESTÉTICA === */}
          {aspiranteInfo.pre_validapago === "1" ? (
            <div style={{ marginTop: "15px" }}>
              <h3>Estado de Pago</h3>
              <div style={{ border: "2px solid #28a745", padding: "20px", borderRadius: "8px", backgroundColor: "#f8fff9", boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}>
                <h3 style={{ margin: "0 0 10px 0", color: "#137333", display: "flex", alignItems: "center", gap: "8px" }}>
                  ✅ Pago Registrado Exitosamente
                </h3>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", fontSize: "0.95rem", color: "#333" }}>
                  <p className="sin-margen"><strong>Referencia de cobro:</strong> {aspiranteInfo.referencia_pagada}</p>
                  <p className="sin-margen"><strong>Autorización / Folio:</strong> {aspiranteInfo.pre_intfolio_banco}</p>
                  <p className="sin-margen"><strong>Fecha de registro:</strong> {aspiranteInfo.fecha_pago}</p>
                  {aspiranteInfo.nombre_banco && (
                    <p className="sin-margen"><strong>Banco:</strong> {aspiranteInfo.nombre_banco}</p>
                  )}
                  {aspiranteInfo.nombre_origen && (
                    <p className="sin-margen"><strong>Método:</strong> {aspiranteInfo.nombre_origen}</p>
                  )}
                  {aspiranteInfo.importe_pagado && (
                    <p className="sin-margen"><strong>Importe pagado:</strong> ${parseFloat(aspiranteInfo.importe_pagado).toFixed(2)}</p>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <>
              {/* 1. Cambiamos el título a "Detalle:" */}
              <h3>Detalle:</h3>
              <div style={{ marginTop: "15px" }}>
                {aspiranteInfo.referencias && aspiranteInfo.referencias.length > 0 ? (
                  <div style={{ border: "1px solid #ccc", padding: "15px", marginBottom: "15px", borderRadius: "8px", backgroundColor: "#fff", boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "15px" }}>
                      
                      {/* LADO IZQUIERDO: CONCEPTO */}
                      <div>
                        <h4 style={{ margin: "0", color: "#0056b3", fontSize: "1.1rem" }}>
                          Pago de Derecho a Examen de Admisión
                        </h4>
                      </div>

                      {/* LADO DERECHO: MONTO Y BOTONES */}
                      <div style={{ textAlign: "right", minWidth: "220px" }}>
                        <h3 style={{ color: "#28a745", margin: "0 0 10px 0", fontSize: "1.5rem" }}>
                          ${parseFloat(aspiranteInfo.referencias[0].monto).toFixed(2)}
                        </h3>
                        
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                          <AvisoSoloLectura visible={soloLectura} />
                          {/* Rol 2: cobra; Administrador: lo ve deshabilitado; rol 3 (sin Pinpad): no lo ve */}
                          {veCobroConPinpad(rolCajero) && (
                            <button 
                              onClick={procesarCobroPinpad}
                              disabled={soloLectura || loadingValidacion}
                              title={soloLectura ? MENSAJE_SOLO_LECTURA : undefined}
                              className="btn-select" 
                              style={{ fontSize: "0.9rem", padding: "8px 12px", backgroundColor: "#0056b3", color: "white", border: "none", borderRadius: "4px", cursor: soloLectura ? "not-allowed" : "pointer" }}
                            >
                              {loadingValidacion ? "⏳ Procesando..." : "💳 Cobrar con Pinpad"}
                            </button>
                          )}

                          {veValidarPago(rolCajero) && (
                            <button
                              onClick={() => abrirModalValidacion()}
                              disabled={soloLectura || loadingValidacion}
                              title={soloLectura ? MENSAJE_SOLO_LECTURA : undefined}
                              className="btn-select validar"
                              style={{ fontSize: "0.9rem", padding: "8px 12px", backgroundColor: "#28a745", color: "white", border: "none", borderRadius: "4px", cursor: soloLectura ? "not-allowed" : "pointer" }}
                            >
                              {"🏦 Validar Voucher"}
                            </button>
                          )}
                        </div>
                      </div>

                    </div>
                  </div>
                ) : (
                  <p style={{ color: "#666", fontStyle: "italic" }}>El aspirante no cuenta con líneas de captura generadas en este ciclo.</p>
                )}
              </div>
            </>
          )}
        </div>
      )}

      {/* COMPONENTE MODAL DE VALIDACIÓN UNIFICADO */}
      <ModalValidarPago
        mostrar={mostrarModalValidacion && !!aspiranteInfo}
        onClose={cerrarModal}
        onConfirm={confirmarValidacionPago}
        loading={loadingValidacion}
        datosPago={aspiranteInfo ? {
          importe: aspiranteInfo.referencias?.[0]?.monto || 600,
          referenciaBanorte: aspiranteInfo.referencias?.find(r => String(r.banco || "").toLowerCase() === "banorte")?.referencia || "S/R",
          referenciaBBVA: aspiranteInfo.referencias?.find(r => String(r.banco || "").toLowerCase() === "bancomer")?.referencia || "S/R",
          folioTPV: ""
        } : null}
        bancoSeleccionado={bancoSeleccionado}
        setBancoSeleccionado={setBancoSeleccionado}
        folioBanco={folioBanco}
        setFolioBanco={setFolioBanco}
        labelTPV="Captura el Número autorización del banco"
        permitirDiscrepancia={true}
      />

      {/* MODAL DE ÉXITO ESTILO COBRO EXTERNOS */}
      {modalExito && modalExito.visible && (
        <div className="modal-overlay-exito">
          <div className="modal-card-exito">
            <div className="modal-icon-exito">🎉</div>
            <h2 className="modal-title-exito">¡Cobro Registrado con Éxito!</h2>
            <div className="modal-detalles-exito">
              <div className="detalle-row-exito"><span>Aspirante:</span><strong>{modalExito.nombre}</strong></div>
              <div className="detalle-row-exito"><span>Monto:</span><strong className="monto-resaltado-exito">${modalExito.monto.toLocaleString('en-US', { minimumFractionDigits: 2 })} MXN</strong></div>
              <div className="detalle-row-exito"><span>No. Autorización:</span><strong className="codigo-exito">{modalExito.autorizacion}</strong></div>
              <div className="detalle-row-exito"><span>Referencia:</span><strong className="codigo-exito">{modalExito.referencia}</strong></div>
            </div>
            <button className="btn-modal-aceptar-exito" onClick={() => setModalExito({ ...modalExito, visible: false })}>Aceptar y Continuar</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default VistaCobroAspirantes;